module.exports = __webpack_public_path__ + "static/media/allie06.a722576f.jpg";